export function isHandleValid(v: string | undefined) {
  if (!v) return true
  return /^(\w+([-_]?\w+)*)(\.\w+([-_]?\w+)*)?$/.test(v)
}

export function isUrlValid(v: string | undefined) {
  if (!v) return true
  return /^((ftp|http|https):\/\/)?[^ "]+$/.test(v)
}